// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1BjPs","select":"Header_select__60DNV","clinic":"Header_clinic__2Gtgp"};